import Home from "../../views/Home";
import Presentation from "../../views/Presentation";
import NewsIndex from "../../views/news/Index";
import NewsList from "../../views/news/List";
import NewsDetails from "../../views/news/Details";
import Fidelity from "../../views/fidelity/Index";

export default [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {showNav: true}
    },
    {
        path: '/presentazione',
        name: 'presentation',
        component: Presentation,
        meta: {showNav: true}
    },
    {
        path: '/news',
        component: NewsIndex,
        children: [
            {
                path: '',
                name: 'news.list',
                component: NewsList,
                meta: {showNav: true}
            },
            {
                path: 'dettaglio/:id',
                name: 'news.details',
                component: NewsDetails,
                meta: {showNav: true}
            }
        ]
    },
    {
        path: '/fidelity',
        name: 'fidelity',
        component: Fidelity,
        meta: {showNav: true}
    }
]
